<template>
  <div class="login">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
      <!-- <h3 class="title">标书智能体管理系统</h3> -->
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          type="text"
          auto-complete="off"
          placeholder="账号"
        >
          <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon"/>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon"/>
        </el-input>
      </el-form-item>
      <!-- <el-form-item prop="code">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="短信验证码"
          style="width: 63%"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon"/>
        </el-input>
        <el-button class="send-sms-button" type="primary" :disabled="sendSmsButton.disabled" @click="sendSmsButtonClick()">{{
            sendSmsButton.value
          }}
        </el-button>
      </el-form-item> -->
      <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <div style="float: right;" v-if="register">
          <router-link class="link-type" :to="'/register'">立即注册</router-link>
        </div>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <!-- <span style="color: black">@2025  xxxxxxxxx</span> -->
    </div>
    <el-dialog title="请输入验证码" :visible.sync="imgCaptcha.open" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="imgCaptchaForm" :model="imgCaptcha" :rules="imgCaptcha.rules" class="login-form" @submit.native.prevent>
        <el-form-item prop="code">
          <el-input
            v-model="imgCaptcha.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 63%"
            @keyup.enter.native="checkImgCode"
          >
            <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon"/>
          </el-input>
          <div class="login-code">
            <img :src="imgCaptcha.codeUrl" @click="getImgCode" class="login-code-img"/>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkImgCode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getImgCode, checkImgCode } from '@/api/login'
import { sendSmsCaptchaCode } from '@/api/sms/record'
import Cookies from 'js-cookie'
import { encrypt, decrypt } from '@/utils/jsencrypt'

export default {
  name: 'Login',
  data() {
    return {
      sendSmsButton: {
        disabled: false,
        value: '点击获取验证码'
      },
      loginForm: {
        username: '',
        password: '',
        rememberMe: false,
        code: '',
        uuid: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'change', message: '请输入您的账号' }
        ],
        password: [
          { required: true, trigger: 'change', message: '请输入您的密码' }
        ],
        code: [{ required: true, trigger: 'change', message: '请输入短信验证码' }]
      },
      loading: false,
      // 注册开关
      register: false,
      redirect: undefined,
      imgCaptcha: {
        code: null,
        codeUrl: '',
        uuid: null,
        enabled: true,
        open: false,
        rules: {
          code: [{ required: true, trigger: 'change', message: '请输入图片中的验证码' }]
        }
      }
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getCookie()
  },
  methods: {
    sendSmsButtonClick() {
      if (!this.loginForm.username) {
        this.$message.warning('请输入账号')
        return
      }
      this.getImgCode()
    },
    getImgCode() {
      getImgCode().then(res => {
        this.imgCaptcha.enabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.imgCaptcha.enabled) {
          // 开启图片验证码
          this.imgCaptcha.open = true
          this.imgCaptcha.codeUrl = 'data:image/gif;base64,' + res.img
          this.imgCaptcha.uuid = res.uuid
          this.imgCaptcha.code = ''
        } else {
          // 未开启图片验证码,直接发送短信
          this.imgCaptcha.open = false
          this.sendSmsCaptchaCode()
        }
      })
    },
    checkImgCode() {
      this.$refs['imgCaptchaForm'].validate(valid => {
        if (valid) {
          const params = { uuid: this.imgCaptcha.uuid, code: this.imgCaptcha.code }
          checkImgCode(params).then(res => {
            if (res.code === 200) {
              this.imgCaptcha.open = false
              // 图形验证码正确,发送短信验证码
              this.sendSmsCaptchaCode()
            }
          })
        }
      })

    },

    sendSmsCaptchaCode() {
      // 倒计时
      let count = 60
      this.sendSmsButton.disabled = true
      this.sendSmsButton.value = count + '秒后重新获取'
      let timer = setInterval(() => {
        count = count - 1
        if (count === 0) {
          //清除多次执行定时器
          clearInterval(timer)
          this.sendSmsButton.disabled = false
          this.sendSmsButton.value = '点击获取验证码'
        } else {
          this.sendSmsButton.value = count + '秒后重新获取'
        }
      }, 1000)
      sendSmsCaptchaCode(this.loginForm.username).then(res => {
        this.loginForm.uuid = res.data
      })
    },
    getCookie() {
      const username = Cookies.get('username')
      const password = Cookies.get('password')
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.loginForm.rememberMe) {
            Cookies.set('username', this.loginForm.username, { expires: 30 })
            Cookies.set('password', encrypt(this.loginForm.password), { expires: 30 })
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 })
          } else {
            Cookies.remove('username')
            Cookies.remove('password')
            Cookies.remove('rememberMe')
          }
          this.$store.dispatch('Login', this.loginForm).then(() => {
            this.$router.push({ path: this.redirect || '/' }).catch(() => {
            })
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.7)), url("../assets/images/login-background.jpg");
  background-size: cover;
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.login-code-img {
  height: 38px;
}

.send-sms-button {
  float: right;
  width: 35%;
  height: 38px;
  text-align: center;
  font-size: 11px
}
</style>
